const messages = {
  title: "Marketinški pristanci",
  required: "Obavezno",
  answered: "✓ Odgovoreno",
  read: "Pročitano",
  notRead: "Nije pročitano",
  alreadyAnswered: "Već odgovoreno",
  requiredQuestionsMustBeAccepted:
    "Potrebno je prihvatiti još {count} obaveznih pitanja",
  pleaseAnswerQuestions: "Molimo vas da odgovorite na sledeća pitanja:",
  iAccept: "Prihvatam",
  scrollToUnlock: "Za otključavanje pomerite do kraja",
  fieldRequired: "Ovo polje je obavezno",
  scrollToContinue: "↓ Za nastavak pomerite do kraja",
  saving: "Čuvanje...",
  saveConsents: "Sačuvaj pristanke",
  allRequiredAccepted: "✓ Sva obavezna pitanja prihvaćena",
  requiredConsentsCompleted:
    "{completed}/{total} obaveznih pristanaka popunjeno",
  selectConsentToView:
    "Izaberite pristanak sa liste da biste videli sadržaj",
  readAllContentFirst: "Prvo pročitajte ceo sadržaj: {names}",
  acceptAllRequiredIn:
    "Prihvatite sva obavezna pitanja u: {names}",
  acceptAllBeforeSaving:
    "Pre čuvanja prihvatite sva obavezna pitanja.",
  failedToSave: "Pristanci nisu sačuvani. Pokušajte ponovo.",
  errorSaving:
    "Došlo je do greške pri čuvanju pristanaka. Pokušajte ponovo.",
  failedToLoad: "Pristanci nisu učitani. Osvežite stranicu.",
  viewPdf: "Pogledaj PDF",
  requiredConsentTitle: "Obavezni pristanak",
  acceptAndContinue: "Prihvati i nastavi",
};

export default {
  messages,
};
